"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _categoryList = _interopRequireDefault(require("@/views/videoChannel/weChatcategoryAndBrand/categoryList"));
var _brandList = _interopRequireDefault(require("@/views/videoChannel/weChatcategoryAndBrand/brandList"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
// +---------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +---------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +---------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +---------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +---------------------------------------------------------------------
var _default = exports.default = {
  name: 'weChatcategoryAndBrand',
  components: {
    BrandList: _brandList.default,
    CategoryList: _categoryList.default
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},
  methods: {}
};